import React, { Component, Fragment } from 'react'


class SoundControlsUI extends Component {


    constructor() {

        super()
        this.audioRef = React.createRef();
        this.seekbarRef = React.createRef();
    }

    state = {
        value: 0
    }

    componentDidMount=()=>{
        this.setState({value:0})
    }

    componentWillReceiveProps=(props)=>{
        this.setState({value:0})
    }


    render = () => {

        let { app, quizViewer, activity } = this.props

        let { quizViwerModel } = quizViewer.state

        let{selectedStyle}=activity.soundModel

        let soundSrc = activity.getResRootPath() + "/" + activity.soundModel.soundRelativeUrl
        return (

            <Fragment>
                <div  style={(selectedStyle!=null)?selectedStyle[0].style:{}}>
                    {(activity.soundModel.enabled) ?


                        <Fragment>

                            <audio onLoadedMetadata={this.handleOnLoadAudio}
                                onTimeUpdate={this.handleAudioTimeUpdate}
                                onEnded={() => this.audioRef.current.currentTime = 0}
                                src={soundSrc} ref={this.audioRef}></audio>


                            <div
                            //  style={(selectedStyle!=null)?selectedStyle[1].style:{}}
                             >
                                <input id="seek_bar" ref={this.seekbarRef}
                                    // style={(selectedStyle!=null)?selectedStyle[2].style:{}}
                                    className={(selectedStyle!=null)?selectedStyle[2].class:""}
                                    onMouseDown={() => this.audioRef.current.pause()}
                                    onMouseUp={() => this.audioRef.current.play()}
                                    type="range" min="0" step="0.25" value={this.state.value}
                                    onChange={this.handleSeekbarOnChange} />
                            </div>




                            <div >
                                <div onClick={this.pauseSound} className= "pause-btn border-change app-content-bg-change" style= {{ display: "inline-block", width: "50px", height: "50px", borderRadius: "50%", backgroundColor: "gray", border: "solid 4px", borderColor: "gray" }}></div>
                                <div onClick={this.playSound} className="play-btn border-change app-content-bg-change" style={{ position: "relative", top: "10px", display: "inline-block", width: "70px", height: "70px", borderRadius: "50%", backgroundColor: "gray", border: "solid 4px", borderColor: "gray" }}></div>

                                <div onClick={this.replaySound} className="replay-btn border-change app-content-bg-change"  style= {{ display: "inline-block", width: "50px", height: "50px", borderRadius: "50%", backgroundColor: "gray", border: "solid 4px", borderColor: "gray" }}></div>
                            </div>
                        </Fragment>

                        :
                        <></>}
                </div>
            </Fragment>
        )
    }


    handleOnLoadAudio = () => {
        this.seekbarRef.current.max = this.audioRef.current.duration
    }


    playSound = () => {
        this.audioRef.current.play()

        let { quizViewer } = this.props
        quizViewer.setCurrentSound(this.audioRef.current)
    }

    pauseSound = () => {
        this.audioRef.current.pause()
    }

    replaySound = () => {

        this.audioRef.current.pause()
        this.audioRef.current.currentTime = 0;
    }

    handleSeekbarOnChange = (e) => {


        this.audioRef.current.currentTime = e.target.value

        this.setState({ value: e.target.value })

    }

    handleAudioTimeUpdate = () => {
        this.setState({ value: this.audioRef.current.currentTime })
    }
}

export default SoundControlsUI;